import { render, staticRenderFns } from "./tilda_fields_tab.vue?vue&type=template&id=0b49f68e&scoped=true&"
import script from "./tilda_fields_tab.vue?vue&type=script&lang=js&"
export * from "./tilda_fields_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49f68e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b49f68e')) {
      api.createRecord('0b49f68e', component.options)
    } else {
      api.reload('0b49f68e', component.options)
    }
    module.hot.accept("./tilda_fields_tab.vue?vue&type=template&id=0b49f68e&scoped=true&", function () {
      api.rerender('0b49f68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/tilda/location/tabs/tilda_fields_tab.vue"
export default component.exports